import {
  ExpandedContainer,
  ExpandedContent,
  FixedContainer,
} from '../../containers/Mobile/Profile/HorizentalFolderView/styles';
import styled from 'styled-components';
import LocalIcon from '../../ui/LocalIcon';
import SanitizedHTML from 'react-sanitized-html';
import React, { useEffect, useState } from 'react';
import PageCKEditor from '../FileManager/ItemsViewer/Quill/PageCkEditor';
import './index.css';
import Button from '../Button/Button';
import i18n from '../../i18n';
import { ITagView } from '../../store/providers/providerTypes';
import AudioView from './MultiMediaView/AudioView';
import { Banner, Content } from './styles';
import VideoView from './MultiMediaView/VideoView';
import PdfViewer from '../FileViewer/PdfViewer';
import OfficeViewer from 'components/FileViewer/OfficeViewer';

import { getAppRastechProxyUrl } from 'components/GuideModal/GuideModal';
import { black, boxShadow1 } from 'utils/style/colors';
import IsolatedHTML from './IsolatedHtml';

type TContentType =
  | 'audio'
  | 'video'
  | 'document'
  | 'pdf'
  | 'image'
  | 'compressed'
  | 'office';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  contentType: TContentType;
  data: any;
  logo: string;
  logoName: string;
}

const Header = styled.header`
  position: sticky;
  top: 0;
  left: 0;
  width: 80%;
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  margin: 2rem auto;
`;

export const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 1rem;
  width: 100%;
  padding: 0 1rem;
  height: 95vh;
`;

const Main = styled.main`
  width: ${(props) => (props.isFullScreen ? '100%' : '80%')};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  color: ${black};
  gap: 0.5rem;

  @media screen and (max-width: 800px) {
    width: 100%;
  }
`;

const Logo = styled.img`
  height: 6rem;
  width: 6rem;
`;

const LogoName = styled.h2`
  font-weight: bold;
  font-size: 1.25rem;
  margin: 1rem 0.5rem;
`;

const ImageBanner = styled(Banner)`
  min-height: 15rem;
  height: auto;
  margin: 1rem;
  overflow: hidden;

  & > img {
    object-fit: contain;
    width: 100%;
    height: 80vh;
  }
`;

// const ButtonGroups = styled.div`
//   display: flex;
//   gap: 1rem;
// `;

const PDFBanner = styled.div`
  min-height: 70vh;
  width: 99%;
  box-shadow: ${boxShadow1};
  border-radius: 0.75rem;

  & > div {
    height: 100%;
    width: 100%;
    border-radius: 1rem;
    box-shadow: ${boxShadow1};
    flex: 1;
  }
`;

// const VideoButtonGroup = styled.div`
//   position: absolute;
//   bottom: 4rem;
//   left: 1rem;
//   margin: 1rem;
//   display: flex;
//   gap: 1rem;
//   flex-direction: row-reverse;
// `;

// export const IconHolder = styled.div`
//   height: 2.5rem;
//   width: 2.5rem;
//   border-radius: 10rem;
//   background: ${exactWhite};
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

export const DownloadPdfContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 3rem;
`;

const MultiTypeModal: React.FC<IProps> = ({
  isOpen,
  onClose,
  contentType = 'page',
  data,
  logo,
  logoName,
}) => {
  const isFullScreen =
    data?.tags?.find((tag: ITagView) => tag?.text === 'conf_fullscreen') ||
    contentType === 'image';
  const [width, setWidth] = useState(window.innerWidth);

  const [pageContent, setPageContent] = useState<any>('');

  const handleDownloadPdf = (url: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = 'file.pdf';
    link.click();
  };

  useEffect(() => {
    if (contentType === 'document' && data) {
      const fetchData = async () => {
        try {
          const res = await fetch(data.document.url);
          const formatedResponse = await res.text();
          setPageContent(formatedResponse);
        } catch (error) {
          console.error('Fetch error:', error);
        }
      };

      fetchData();
    }
  }, [data, contentType]);

  if (
    isOpen &&
    data?.document?.properties?.format === 'quill' &&
    data?.viewType?.includes('display_isolated_html')
  ) {
    return <IsolatedHTML src={data.document.url} />;
  }

  return (
    <FixedContainer isSelected={isOpen}>
      <ExpandedContainer isSelected={isOpen}>
        <ExpandedContent isFullScreen={isFullScreen}>
          <ContentBox>
            <Header>
              <LocalIcon
                iconName="close-square.svg"
                onClick={onClose}
                color="no-color"
                isLink={true}
              />
              <Button
                onClick={() => {
                  try {
                    navigator.share({
                      title: data?.name,
                      url: window.location.href,
                    });
                  } catch (error) {
                    /*do nothing*/
                  }
                }}
              >
                {i18n.t('share', { ns: 'modals' }) as string}
              </Button>
            </Header>
            <Main isFullScreen={isFullScreen}>
              {logo && <Logo src={logo} />}
              <LogoName>
                <SanitizedHTML
                  allowedAttributes={{ span: ['style'] }}
                  html={logoName}
                />
              </LogoName>
              {contentType === 'document' ? (
                <>
                  <Content isFullScreen={isFullScreen}>
                    <h3>{data?.name}</h3>
                    <PageCKEditor
                      item={data}
                      editing={false}
                      updateContent={() => {
                        /*console.log();*/
                      }}
                      saving={false}
                      content={pageContent}
                    />
                  </Content>
                </>
              ) : contentType === 'audio' ? (
                <AudioView
                  data={data}
                  width={width}
                  setWidth={(width: number) => setWidth(width)}
                />
              ) : contentType === 'image' ? (
                <>
                  <ImageBanner>
                    {data.document.url && (
                      <img src={`${data.document.url}`} alt={data.name} />
                    )}
                  </ImageBanner>
                </>
              ) : contentType === 'pdf' ? (
                <>
                  {width > 650 ? (
                    <PDFBanner>
                      <PdfViewer
                        pdfURL={
                          data.document.url !== '' ? data.document.url : ''
                        }
                        name={data.name as string}
                      />
                    </PDFBanner>
                  ) : (
                    <DownloadPdfContainer>
                      <div>
                        <LocalIcon
                          iconName={'pdf.svg'}
                          color={'no-color'}
                          type={'xlg'}
                        />
                      </div>
                      <div
                        style={{ fontSize: '1.25rem', fontWeight: 400 }}
                      >{`${data.document.properties.displayName}.pdf`}</div>
                      <Button
                        onClick={() =>
                          handleDownloadPdf(
                            data.document.url !== '' ? data.document.url : ''
                          )
                        }
                        type={'button'}
                        color={'black-outline'}
                      >
                        {i18n.t('download', { ns: 'modals' }) as string}
                      </Button>
                    </DownloadPdfContainer>
                  )}
                </>
              ) : contentType === 'office' ? (
                <div
                  style={{ width: '100%', height: '100%', overflow: 'hidden' }}
                >
                  <OfficeViewer
                    fileUrl={getAppRastechProxyUrl(
                      data.document?.url as string
                    )}
                    fileType={data.document?.properties?.format}
                  />
                </div>
              ) : (
                <VideoView data={data} />
              )}
            </Main>
          </ContentBox>
        </ExpandedContent>
      </ExpandedContainer>
    </FixedContainer>
  );
};

export default MultiTypeModal;
